import { projectSettingsPagePath } from './projectSettingsNav'

const LAST_PROJECT_ID_KEY = 'veilstream_last_project_id'

export function rememberLastProjectId(projectId: string | number | null | undefined): void {
  const id = String(projectId ?? '').trim()
  if (!/^\d+$/.test(id) || id === '0') return
  try {
    sessionStorage.setItem(LAST_PROJECT_ID_KEY, id)
  } catch {
    // ignore quota / private-mode failures
  }
}

export function readLastProjectId(): string | null {
  try {
    const id = sessionStorage.getItem(LAST_PROJECT_ID_KEY)?.trim() ?? ''
    if (!/^\d+$/.test(id) || id === '0') return null
    return id
  } catch {
    return null
  }
}

function normalizeProjectIds(ids: Array<number | string> | null | undefined): string[] {
  const out: string[] = []
  const seen = new Set<string>()
  for (const raw of ids ?? []) {
    const id = String(raw).trim()
    if (!/^\d+$/.test(id) || id === '0' || seen.has(id)) continue
    seen.add(id)
    out.push(id)
  }
  return out
}

/** Sidebar back target from a database or synthetic DB into its project Data page. */
export function databaseProjectExitPath(opts: {
  synthetic: boolean
  attachedProjectIds?: Array<number | string> | null
  lastProjectId?: string | null
  loading?: boolean
  fallback?: string
}): string {
  const page = opts.synthetic ? 'synthetic-databases' : 'databases'
  const fallback = opts.fallback ?? '/projects'
  const last = (opts.lastProjectId ?? '').trim()
  const lastOk = /^\d+$/.test(last) && last !== '0'
  const attachmentsKnown = opts.attachedProjectIds != null

  if (opts.loading || !attachmentsKnown) {
    return lastOk ? projectSettingsPagePath(last, page) : fallback
  }

  const ids = normalizeProjectIds(opts.attachedProjectIds)
  const projectId = lastOk && ids.includes(last) ? last : ids[0]
  if (!projectId) return fallback
  return projectSettingsPagePath(projectId, page)
}
